/* Site-wide gift guard: the ₹0 Free Jerky is given exactly once, and only with a
   real bundle. Enforces the cart state everywhere (Rebuy drawer, cart page, ajax
   cart). It is read-only unless it must correct the gift line, and it NEVER
   touches the original fetch request/response, so it cannot break add-to-cart.
   A light poll runs ONLY while the gift is actually in the cart (so normal
   traffic pays nothing). The server-side order monitor is the backstop for
   anyone who bypasses the storefront entirely (JS off / raw API). */
(function () {
  'use strict';
  var GIFT = 50176821854482;        // Free Classic Chicken Jerky (₹0 gift SKU)
  var busy = false, timer = null, poll = null;

  function setPoll(on) {
    if (on && !poll) poll = setInterval(function () { if (!document.hidden) schedule(); }, 4000);
    else if (!on && poll) { clearInterval(poll); poll = null; }
  }

  function guard() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var gift = items.filter(function (i) { return i.variant_id === GIFT; })[0];
        setPoll(!!gift);                          // only watch sessions that actually hold the gift
        if (!gift) return;
        // A gift is legitimate when the flow that granted it stamped the line:
        //   _kv_free_jerky -> 90-day plan (kv-weight-plan-selector)
        //   _kv_acq_gift   -> ACQ landing page gift checkbox
        // Those flows add a single supplement line, which carries no `_bundle`
        // property, so the bundle rule alone deleted the gift they had just
        // granted. Build-a-Bundle still qualifies via the 2-line rule below.
        // How many gifts this cart is entitled to.
        //   90-day plan  -> one per DISTINCT 90-day supplement line. A plan is one line
        //                   whatever its pack count (a 27-45kg plan is 3x480g on ONE line),
        //                   so count lines, never quantities.
        //   ACQ LP gift  -> exactly one.
        //   Bundle       -> one, and only with a real 2+ line bundle.
        //   anything else-> zero, remove it.
        var gp = gift.properties || {};
        var bundleLines = items.filter(function (i) { return i.properties && i.properties._bundle; }).length;

        // Count DISTINCT PRODUCTS, never lines. One plan can be several lines:
        // planConfig 12-26/90 is [240g x1, 480g x1] and 46+/90 is multi-line too,
        // yet both are a SINGLE supplement on a single plan. Counting lines would
        // hand those bands a second free jerky.
        var seen = {}, ninetyProducts = 0;
        items.forEach(function (i) {
          if (i.properties && i.properties['Plan'] === '90 Day Plan' && !seen[i.product_id]) {
            seen[i.product_id] = 1;
            ninetyProducts++;
          }
        });

        var allowed;
        if (gp._kv_free_jerky)     allowed = ninetyProducts;
        else if (gp._kv_acq_gift)  allowed = 1;
        else                       allowed = (bundleLines >= 2) ? 1 : 0;

        var target = (gift.quantity !== allowed) ? allowed : null;
        if (target === null) return;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: gift.key, quantity: target })
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(guard, 400); }

  function isCartMutation(url, method) {
    try { return /post/i.test(method || 'post') && /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url)); }
    catch (e) { return false; }
  }

  // Fast path: re-check after any cart-mutating fetch (works when we stay the
  // outermost fetch wrapper). Best-effort only — the poll above is the guarantee.
  // The original promise is returned untouched, so this can never break a request.
  var of = window.fetch;
  if (typeof of === 'function') {
    window.fetch = function (input, init) {
      var p = of.apply(this, arguments);
      try {
        var url = (typeof input === 'string') ? input : (input && input.url);
        var method = (init && init.method) || (input && input.method);
        if (isCartMutation(url, method)) { p.then(schedule, function () {}); }
      } catch (e) {}
      return p;
    };
  }

  // Initial check (enables the poll if a gift is already in the cart) + refocus.
  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
})();
